const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^[+()\d\s/-]{6,}$/;

const hasValue = (value: string): boolean => value.trim().length > 0;

export const defaultValidators = {
    requiredText: (value: string): boolean => hasValue(value),

    optionalEmail: (value: string): boolean =>
        !hasValue(value) || emailPattern.test(value),

    optionalPhone: (value: string): boolean =>
        !hasValue(value) || phonePattern.test(value),

    requiredCheckbox: (value: boolean): boolean => value,

    requiredDateIso: (value: string): boolean => {
        if (!hasValue(value)) {
            return false;
        }

        return !Number.isNaN(Date.parse(value));
    },
};

export const createInputValidator = (
    type: string,
    required: boolean
): ((value: string) => boolean) => {
    if (required) {
        if (type === "email") {
            return (value: string) =>
                defaultValidators.requiredText(value) &&
                defaultValidators.optionalEmail(value);
        }

        if (type === "tel") {
            return (value: string) =>
                defaultValidators.requiredText(value) &&
                defaultValidators.optionalPhone(value);
        }

        return defaultValidators.requiredText;
    }

    if (type === "email") {
        return defaultValidators.optionalEmail;
    }

    if (type === "tel") {
        return defaultValidators.optionalPhone;
    }

    return () => true;
};

export const createTextValidator = (
    required: boolean
): ((value: string) => boolean) => {
    if (required) {
        return defaultValidators.requiredText;
    }

    return () => true;
};

export const createCheckboxValidator = (
    required: boolean
): ((value: boolean) => boolean) => {
    if (required) {
        return defaultValidators.requiredCheckbox;
    }

    return () => true;
};

export const createDateValidator = (
    required: boolean
): ((value: string) => boolean) => {
    if (required) {
        return defaultValidators.requiredDateIso;
    }

    return () => true;
};

